export const TEMPLATE_OPTIONS_MAP = {
    project: ['modules', 'project_embeds', 'automation', 'milestones', 'task_groups', 'tasks', 'docs', 'files'],
    milestone: ['description', 'start', 'end', 'tasks', 'fields'],
    task: ['description', 'labels', 'start_date', 'due_date', 'subtasks', 'fields', 'embed_url'],
    document: []
} as const

export const TEMPLATE_FIELDS_MAP = {
    project: [],
    milestone: ['start', 'end'],
    task: ['start_date', 'due_date'],
    document: []
} as const;
